import { withTranslation } from 'gatsby-plugin-react-i18next'
import React, { Component } from 'react'
import './FileSelector.css'

class FileSelector extends Component {
	constructor(props) {
		super(props)
		this.state = {
			selectedFileName: null,
			dragOver: false
		}
		this.inputRef = React.createRef()
		this.onDragEnter = this.onDragEnter.bind(this)
		this.onDragLeave = this.onDragLeave.bind(this)
	}
	onDragEnter() {
		this.setState({ dragOver: true })
	}
	onDragLeave() {
		this.setState({ dragOver: false })
	}
	onInputChange(e) {
		const { onChange } = this.props
		onChange(e)
		if (e.target.files && e.target.files[0]) {
			this.setState({ 
				selectedFileName: e.target.files[0].name,
				dragOver: false
			})
		}
	}
	getFormatterExtensionList() {
		const { t, accept } = this.props
		const acceptArr = accept.split(',').map(el => el.trim())
		const formattedExtensions = {
			'image/png': 'PNG',
			'image/jpeg': 'JPG',
			'.pdf': 'PDF'
		}
		const extensionsText = acceptArr.reduce((acc, cur, ind) => {
			if (formattedExtensions[cur]) {
				if (ind !== acceptArr.length - 1) {
					return `${acc}${formattedExtensions[cur]}, `
				} else {
					return `${acc}${t(`global:form.fileSelector.extension.or`)} ${formattedExtensions[cur]}`
				}
			}
			return acc
		}, '')
		return `${t(`global:form.fileSelector.extension.accepting`)} ${extensionsText}`
	}
	componentDidMount() {
		const input = this.inputRef.current
		input.addEventListener('dragenter', this.onDragEnter)
		input.addEventListener('dragleave', this.onDragLeave)
	}
	render() {
		const { t, label, name, accept } = this.props
		const { dragOver, selectedFileName } = this.state
		return (
			<div className={`file-selector-wrap ${dragOver ? 'drag-over' : ''} ${selectedFileName ? 'filled' : ''}`}>
				<input 
					id={name}
					name={name}
					className="file-selector" 
					type="file" 
					onChange={e => this.onInputChange(e)}
					accept={accept}
					ref={this.inputRef} 
				/>	
				<label 
					htmlFor={name} 
					className={`file-selector-label ${selectedFileName ? 'hidden' : ''}`}
				>
					{t(`global:form.fileSelector.prompt`)}
				</label>
				<label 
					htmlFor={name} 
					className={`file-selector-label alt ${selectedFileName ? 'hidden' : ''}`}
				>
					{t(`global:form.fileSelector.alt`)}
				</label>
				<label 
					htmlFor={name} 
					className={`file-selector-label alt ${selectedFileName ? 'hidden' : ''}`}
				>
					{this.getFormatterExtensionList()}
				</label>
				{selectedFileName && (
					<label 
						htmlFor={name} 
						className="selected-file-name"
					>
						{`${t(`global:form.fileSelector.uploaded`)}: ${selectedFileName}`}
					</label>
				)}
			</div>
		)
	}
}
export default withTranslation(['global'])(FileSelector)
